import React from "react";

export interface HardLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

/**
 * HardLink is a simple anchor ("a") component for external or internal navigation.
 *
 * Because Next.js link and prefetch use various parameter causing high cache miss rate.
 * Current solution is to use simple a tag (hard navigation) to be able to properly cache the page.
 *
 * Use-case should be where caching really has greay impact, like product page.
 *
 * https://github.com/vercel/next.js/issues/65335#issuecomment-2909872114
 */
export const HardLink: React.FC<HardLinkProps> = ({ children, ...props }) => {
  return (
    <a {...props}>
      {children}
    </a>
  );
};
